<template>
  <div style="margin-top: 30px; padding:11px;">

    <!-- YAPI DEĞİŞTİRİLDİ: Üç sütunlu bir yapı oluşturuldu -->
    <div class="d-flex justify-content-between align-items-center">

      <!-- 1. Sütun (Sol) -->
      <div>
        <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="prepareNewCompany">
          Firma Ekle
        </button>
      </div>

      <!-- 2. Sütun (Orta - Arama Çubuğu) -->
      <!-- Arama çubuğunun çok küçülmemesi için bir minimum genişlik eklendi -->
      <div class="flex-grow-1 mx-4" style="max-width: 400px;">
        <div class="input-group">
           <span class="input-group-text" id="basic-addon1">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16"><path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/></svg>
          </span>
          <input
              type="text"
              class="form-control"
              placeholder="Firma adına göre ara..."
              v-model="companySearchTerm"
          />
        </div>
      </div>

      <!-- 3. Sütun (Sağ) -->
      <div>
        <button type="button" class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#filterModal">
          Filtre
        </button>
        <button type="button" class="btn btn-success ms-2" @click="exportToExcel">
          Excel'e Aktar
        </button>
      </div>
    </div>
    <br>

    <div class="modal fade" id="filterModal" tabindex="-1" aria-labelledby="filterModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="filterModalLabel">Gösterilecek Alanları Seçin</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="companyName" v-model="fieldsVisibility.companyName">
              <label class="form-check-label" for="companyName">
                Firma Adı
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="companyStatus" v-model="fieldsVisibility.companyStatus">
              <label class="form-check-label" for="companyStatus">
                Firma Statü
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="companySGK" v-model="fieldsVisibility.companySGK">
              <label class="form-check-label" for="companySGK">
                Firma SGK Sicil No
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="companyClass" v-model="fieldsVisibility.companyClass">
              <label class="form-check-label" for="companyClass">
                Firma Sınıf
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="companyEmployeeCount" v-model="fieldsVisibility.companyEmployeeCount">
              <label class="form-check-label" for="companyEmployeeCount">
                Firma Çalışan Sayısı
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="companyHazardClass" v-model="fieldsVisibility.companyHazardClass">
              <label class="form-check-label" for="companyHazardClass">
                Firma Tehlike Sınıfı
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="companySector" v-model="fieldsVisibility.companySector">
              <label class="form-check-label" for="companySector">
                Firma Sektör
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="companySegment" v-model="fieldsVisibility.companySegment">
              <label class="form-check-label" for="companySegment">
                Firma Segment
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="companyAddress" v-model="fieldsVisibility.companyAddress">
              <label class="form-check-label" for="companyAddress">
                Firma Adres
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="customerRepresentative" v-model="fieldsVisibility.customerRepresentative">
              <label class="form-check-label" for="customerRepresentative">
                Müşteri Temsilcisi
              </label>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Kapat</button>
            <button type="button" class="btn btn-primary" @click="applyFilters" data-bs-dismiss="modal">Uygula</button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table align-middle">
        <thead>
        <tr>
          <td v-if="fieldsVisibility.companyName"><b>Firma Adı</b></td>
          <td v-if="fieldsVisibility.companyStatus"><b>Firma Statü</b></td>
          <td v-if="fieldsVisibility.companySGK"><b>Firma SGK Sicil No</b></td>
          <td v-if="fieldsVisibility.companyClass"><b>Firma Sınıf</b></td>
          <td v-if="fieldsVisibility.companyEmployeeCount"><b>Firma Çalışan Sayısı</b></td>
          <td v-if="fieldsVisibility.companyHazardClass"><b>Firma Tehlike Sınıfı</b></td>
          <td v-if="fieldsVisibility.companySector"><b>Firma Sektör</b></td>
          <td v-if="fieldsVisibility.companySegment"><b>Firma Segment</b></td>
          <td v-if="fieldsVisibility.companyAddress"><b>Firma Adres</b></td>
          <td v-if="fieldsVisibility.customerRepresentative"><b>Müşteri Temsilcisi</b></td>
          <td><b> İşlemler </b></td>

        </tr>
        </thead>

        <tbody>
        <tr v-for="val in paginatedData" v-bind:key="val.id">
          <td v-if="fieldsVisibility.companyName">
            <div :class="{'break-line': val.companyName.length >= 25}">
              <router-link :to="{ name: 'companiesDetails', params: { id: val.id } }">
                {{ val.companyName }}
              </router-link>
            </div>
          </td>
          <td v-if="fieldsVisibility.companyStatus">
            <p v-if="val.isSubcontractor">Alt Firma</p>
            <p v-if="!val.isSubcontractor">Üst Firma</p>
          </td>
          <td v-if="fieldsVisibility.companySGK">{{val.companyRegistrationNumber}}</td>
          <td v-if="fieldsVisibility.companyClass">
            <div v-show="val.companyDetails[0]?.companyClass === 'ACTIVE'">Aktif</div>
            <div v-show="val.companyDetails[0]?.companyClass === 'INACTIVE'">Pasif</div>
            <div v-show="val.companyDetails[0]?.companyClass === 'POTENTIAL'">Potansiyel</div>
          </td>
          <td v-if="fieldsVisibility.companyEmployeeCount">{{ val.companyDetails[0]?.companyEmployeesCount || 'Bilgi Yok' }}</td>
          <td v-if="fieldsVisibility.companyHazardClass">
            <div v-show="val.companyDetails[0]?.companyHazardLesson === 'LESS_DANGEROUS'"> Az Tehlikeli</div>
            <div v-show="val.companyDetails[0]?.companyHazardLesson === 'MANY_DANGEROUS'"> Çok Tehlikeli</div>
            <div v-show="val.companyDetails[0]?.companyHazardLesson === 'DANGEROUS'">Tehlikeli</div>
          </td>
          <td v-if="fieldsVisibility.companySector">{{ val.companyDetails[0]?.companySector || 'Bilgi Yok' }}</td>
          <td v-if="fieldsVisibility.companySegment">{{ val.companyDetails[0]?.companySegment || 'Bilgi Yok' }}</td>
          <td v-if="fieldsVisibility.companyAddress">
            <div :class="{'break-line': val.companyAddresses[0]?.companyAddress.length >= 30}">
              {{ val.companyAddresses[0]?.companyAddress || 'Bilgi Yok' }}
            </div>
          </td>
          <td v-if="fieldsVisibility.customerRepresentative">{{ val.customerRepresentativeUserId?.name || 'Temsilci Yok' }}</td>
          <td>
            <button type="button" class="btn btn-danger"
                    data-bs-toggle="modal"
                    data-bs-target="#companyDeleteModal"
                    @click="setDeleteId(val.id)">Sil</button>
             
            <button type="button" class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="editCompany(val.id)">Düzenle</button>
            <div class="modal fade" id="companyDeleteModal" tabindex="-1" aria-labelledby="companyDeleteModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="companyDeleteModalLabel">Silme Onayı</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <p>Bu öğeyi silmek istediğinizden emin misiniz?</p>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">İptal</button>
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="companiesDelete(deleteId)">Evet, Sil</button>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="paginatedData.length === 0">
          <td :colspan="Object.values(fieldsVisibility).filter(v => v).length + 1" class="text-center">
            Arama kriterlerine uygun firma bulunamadı.
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <button @click="prevPage" :disabled="currentPage === 1">Önceki</button>
      <span>Sayfa {{ currentPage }} / {{ totalPages }}</span>
      <button @click="nextPage" :disabled="currentPage === totalPages">Sonraki</button>
    </div>

    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog">
        <div class="modal-content" :class="{ 'wide-modal': step === 4 }"  style=" min-height: 500px; width: 750px; display: flex; flex-direction: column;">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel"> {{ isEditing ? 'Firma Düzenle' : 'Firma Ekle' }}</h5>
            <button type="button" style="background-color: #2419d2;" class="btn-close" @click="showCloseConfirmation"></button>
          </div>
          <div class="modal-body" style="overflow-y: auto;" v-if="step === 1">
            <div class="mb-3">
              <label for="exampleFormContFirmaInput1" class="form-label">Firma Adı *</label>
              <input type="text" class="form-control" v-model="itemsCompany.companyName" id="exampleFormContFirmaInput1" placeholder="Firma Adı">
            </div>
            <hr>
            <label for="exampleFormContFirmaInput1" class="form-label">Firma Türü</label>
            <div class="form-check">
              <input class="form-check-input"
                     type="radio"
                     id="flexRadioDefault1"
                     v-model="itemsCompany.isSubcontractor"
                     :value="false"
                     @change="resetParentCompany"
              >
              <label class="form-check-label" for="flexRadioDefault1">
                Ana Firma
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input"
                     type="radio"
                     id="flexRadioDefault2"
                     v-model="itemsCompany.isSubcontractor"
                     :value="true"
              >
              <label class="form-check-label" for="flexRadioDefault2">
                Alt İşveren
              </label>
            </div>

            <div class="mb-3" v-if="itemsCompany.isSubcontractor">
              <div class="mb-3">

                <input
                    type="text"
                    v-model="searchTerm"
                    class="form-control mb-2"
                    placeholder="Firma Ara..."
                />
                <select class="form-select" aria-label="Firma Sınıfı" v-model="itemsCompany.parentCompany">
                  <option
                      v-for="(companies, index) in filteredCompanies"
                      :key="index"
                      :value="companies.id"
                  >
                    {{ companies.companyName }} - {{ companies.companyRegistrationNumber }}
                  </option>
                </select>
              </div>
            </div>

            <hr>
            <div class="mb-3">
              <label for="exampleFormContFirmaInput1" class="form-label">SGK Sicil No</label>
              <input @input="validateSGKNumberInput" type="text" class="form-control" v-model="itemsCompany.companyRegistrationNumber" id="exampleFormContFirmaInput1" placeholder="Sicil">
            </div>

          </div>
          <div class="modal-body" style="overflow-y: auto;" v-if="step === 2">
            <div class="mb-3">
              <label for="exampleFormContFirmaInput1" class="form-label">Firma Sınıfı</label>
              <div class="mb-3">
                <select class="form-select"
                        aria-label="Firma Sınıfı"
                        v-model="itemsDetail.companyClass">
                  <option v-for="(companyLesson, index) in companyLessonData"
                          :key="index"
                          :value="index"
                          :disabled="companyLesson === 'Pasif' && !isEditing">
                    {{ companyLesson }}
                  </option>
                </select>
              </div>
            </div>

            <hr>
            <div class="mb-3">
              <label for="exampleFormContFirmaInput1" class="form-label">Firma Çalışan Sayısı</label>
              <input type="text" @input="validateEmployeeCountInput" class="form-control" id="exampleFormContFirmaInput1" v-model="itemsDetail.companyEmployeesCount" placeholder="Firma Çalışan Sayısı">
            </div>
            <hr>
            <div class="mb-3">
              <label for="exampleFormContFirmaInput1" class="form-label">Firma Tehlike Sınıfı</label>
              <div class="mb-3">
                <select class="form-select" aria-label="Firma Tehlike Sınıfı" v-model="itemsDetail.companyHazardLesson">
                  <option v-for="(companyHazard, index) in companyHazardData" :key="index" :value="index">
                    {{companyHazard}}
                  </option>
                </select>
              </div>
            </div>
            <hr>
            <div class="mb-3">
              <label for="exampleFormContFirmaInput1" class="form-label">Sektör</label>
              <input type="text" class="form-control" id="exampleFormContFirmaInput1" placeholder="Sektör" v-model="itemsDetail.companySector">
            </div>
            <hr>

            <div class="mb-3">
              <label for="exampleFormContFirmaInput1" class="form-label">Segment</label>
              <div class="mb-3">
                <select class="form-select" aria-label="Firma Segmenti" v-model="itemsDetail.companySegment">
                  <option v-for="(segment, index) in companySegmentData" :key="index" :value="index">
                    {{ segment }}
                  </option>
                </select>
              </div>
            </div>

          </div>
          <div class="modal-body" style="overflow-y: auto;" v-if="step === 3">
            <div class="mb-3">
              <label for="exampleFormContFirmaInput1" class="form-label">Firma Adres</label>
              <input type="text" class="form-control" v-model="itemsAddress.companyAddress" id="exampleFormContFirmaInput1" placeholder="Firma Adres">
            </div>
            <hr>
            <div class="mb-3">
              <label for="exampleFormContFirmaInput1" class="form-label">Firma İlçe</label>
              <input type="text" class="form-control" v-model="itemsAddress.companyDistrict" id="exampleFormContFirmaInput1" placeholder="Firma İlçe">
            </div>

            <hr>

            <div class="mb-3">
              <label for="exampleFormContFirmaInput1" class="form-label">Firma İl</label>
              <input type="text" class="form-control" v-model="itemsAddress.companyCity" id="exampleFormContFirmaInput1" placeholder="Firma İl">
            </div>
            <hr>

            <div class="mb-3">
              <label for="exampleFormContFirmaInput2" class="form-label">Müşteri Temsilcisi</label>
              <div class="mb-3">
                <select class="form-select" aria-label="Firma Sınıfı" v-model="itemsCompany.customerRepresentativeUserId">
                  <option v-for="(users, index) in usersData" :key="index" :value="users.id">
                    {{ users.name }}
                  </option>
                </select>
              </div>
            </div>

          </div>
          <div class="modal-body"  style="overflow-y: auto; " v-if="step === 4">

            <div>
              <div v-for="(val, index) in itemsCompanyOfficials" :key="index" class="d-flex justify-content-between align-items-center mb-3">
                <div class="me-3" style="flex: 1;">
                  <label class="form-label">Yetkili Adı Soyadı</label>
                  <input type="text" class="form-control" v-model="val.nameSurname" placeholder="Firma Yetkili Adı Soyadı">
                </div>
                <div class="me-3" style="flex: 1;">
                  <label class="form-label">E-mail</label>
                  <input type="text" class="form-control" v-model="val.email" placeholder="Mail">
                </div>
                <div class="me-3" style="flex: 1;">
                  <label class="form-label">Telefon Numarası</label>
                  <input type="text" class="form-control" v-model="val.phoneNumber" placeholder="Telefon Numarası">
                </div>
                <div class="me-3" style="flex: 1;">
                  <label class="form-label">Görev&Ünvan</label>
                  <input type="text" class="form-control" v-model="val.jobTitle" placeholder="Görev&Ünvan">
                </div>
                <div style="align-self: center; align-items:center; padding-top: 45px;">
                  <button class="btn btn-danger btn-sm" v-if="isAddingCompany" @click="removeOfficial(index)">Sil</button>
                </div>
              </div>
              <hr>
            </div>

            <div class="d-flex justify-content-end">
              <button class="btn btn-primary" v-if="isAddingCompany" @click="addOfficial">Firma Temsilcisi Ekle</button>
            </div>
          </div>



          <div style="display: flex;">
            <button class="btn btn-primary" v-if="step === 2 || step === 3 || step === 4 " @click="previousStep" style="margin-right: auto; margin-left: 15px;">Geri</button>
            <button class="btn btn-primary" v-if="step === 1 || step === 2 || step === 3 " @click="nextStep" :disabled="!itemsCompany.companyName" style="margin-left: auto; margin-right: 15px;">İleri</button>
          </div>
          <div class="modal-footer" v-if="step === 4">
            <button type="button" class="btn btn-secondary" @click="showCloseConfirmation">Vazgeç</button>
            <button type="button" class="btn btn-primary" @click="isEditing ? updateCompany() : createCompany()" :disabled="!itemsCompany.companyName">
              {{ isEditing ? 'Güncelle' : 'Kaydet' }}
            </button>
          </div>
        </div>

      </div>
    </div>

    <!-- Firma Ekle/Düzenle Modal Kapatma Onay Modalı -->
    <div class="modal fade" id="closeConfirmationModal" tabindex="-1" aria-labelledby="closeConfirmationModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="closeConfirmationModalLabel">Kapatma Onayı</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>Formu kapatmak istediğinize emin misiniz? Kaydedilmemiş değişiklikler kaybolacaktır.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Hayır, Devam Et</button>
            <button type="button" class="btn btn-danger" @click="closeCompanyModal">Evet, Kapat</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ts-nocheck

import apiClient from "@/axios";
import * as XLSX from "xlsx";
import * as bootstrap from 'bootstrap';

export default {
  name: "Users",
  data() {
    return {
      // --- ARAMA VE SAYFALAMA ---
      companySearchTerm: "",
      currentPage: 1,
      itemsPerPage: 10,

      // --- MEVCUT VERİLER ---
      searchTerm: "",
      isAddingCompany: true,
      companyModal: null,
      closeConfirmationModal: null,
      fieldsVisibility: {
        companyName: true,
        companyStatus: true,
        companySGK: true,
        companyClass: true,
        companyEmployeeCount: true,
        companyHazardClass: true,
        companySector: true,
        companySegment: true,
        companyAddress: true,
        customerRepresentative: true
      },
      itemsCompanyOfficials: [
        {
          nameSurname: '',
          mail: '',
          phoneNumber: '',
        },
      ],
      isEditing: false,
      deleteId: null,
      itemsCompany:{isSubcontractor:false, parentCompany: null,},
      itemsDetail: {},
      itemsAddress:{},
      itemsCompanyId : null,
      step: 1,
      // --- HATA DÜZELTMESİ: Veri yapıları boş dizi olarak başlatıldı ---
      usersData: [],
      items:{},
      companyCategoriesData: {},
      companySegmentData: {},
      companyLessonData: {},
      companyHazardData: {},
      companiesSubcontractData: [],
      companiesData: [],
      companyRegistrationNumber: null,
      companyTexNumber: null,
      companyEmployeesCount: null,
    };
  },
  watch: {
    companySearchTerm() {
      this.currentPage = 1;
    }
  },
  created() {
    this.getCompanySegmentData();
    this.getCompaniesSubcontractorData();
    this.getCompaniesData();
    this.getUserData();
  },
  mounted() {
    this.$nextTick(() => {
      this.companyModal = new bootstrap.Modal(document.getElementById('exampleModal'));
      this.closeConfirmationModal = new bootstrap.Modal(document.getElementById('closeConfirmationModal'));

      // Modal kapatma event'lerini dinle
      const modalElement = document.getElementById('exampleModal');
      if (modalElement) {
        modalElement.addEventListener('hidden.bs.modal', () => {
          this.cleanupModal();
        });
      }
    });
  },
  computed: {
    filteredCompaniesByName() {
      if (!Array.isArray(this.companiesData)) {
        return [];
      }
      const normalizedTerm = this.normalizeSearch(this.companySearchTerm);
      if (!normalizedTerm) {
        return this.companiesData;
      }
      return this.companiesData.filter(company =>
          this.normalizeSearch(company.companyName).includes(normalizedTerm)
      );
    },

    totalPages() {
      return Math.ceil(this.filteredCompaniesByName.length / this.itemsPerPage);
    },

    paginatedData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredCompaniesByName.slice(start, end);
    },

    filteredCompanies() {
      if (!Array.isArray(this.companiesSubcontractData)) {
        return [];
      }
      const normalizedTerm = this.normalizeSearch(this.searchTerm);
      if (!normalizedTerm) {
        return this.companiesSubcontractData;
      }
      return this.companiesSubcontractData.filter(company =>
          this.normalizeSearch(company.companyName).includes(normalizedTerm)
      );
    }
  },
  methods:{
    normalizeSearch(value) {
      if (value === null || value === undefined) {
        return "";
      }
      return String(value).toLocaleLowerCase("tr-TR");
    },
    cleanupModal() {
      // Modal kapatıldıktan sonra temizlik işlemleri
      // Scroll pozisyonunu korumak için daha güvenilir yaklaşım
      const scrollY = window.scrollY;

      document.querySelectorAll('.modal-backdrop').forEach(backdrop => {
        backdrop.remove();
      });
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      // Scroll pozisyonunu geri yükle
      window.scrollTo(0, scrollY);
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    showCloseConfirmation() {
      this.closeConfirmationModal.show();
    },
    closeCompanyModal() {
      this.closeConfirmationModal.hide();
      if (this.companyModal) {
        this.companyModal.hide();
      } else {
        const modal = document.getElementById('exampleModal');
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) {
          modalInstance.hide();
        }
      }
      // cleanupModal metodu hidden.bs.modal event'i ile otomatik çağrılacak
      this.resetForm();
    },
    prepareNewCompany() {
      this.resetForm();
      this.isEditing = false;
      this.isAddingCompany = true;
    },
    exportToExcel() {
      const visibleFields = {
        "Firma Adı": this.fieldsVisibility.companyName,
        "Firma Statü": this.fieldsVisibility.companyStatus,
        "Firma SGK Sicil No": this.fieldsVisibility.companySGK,
        "Firma Sınıf": this.fieldsVisibility.companyClass,
        "Firma Çalışan Sayısı": this.fieldsVisibility.companyEmployeeCount,
        "Firma Tehlike Sınıfı": this.fieldsVisibility.companyHazardClass,
        "Firma Sektör": this.fieldsVisibility.companySector,
        "Firma Segment": this.fieldsVisibility.companySegment,
        "Firma Adres": this.fieldsVisibility.companyAddress,
        "Müşteri Temsilcisi": this.fieldsVisibility.customerRepresentative,
      };
      const data = this.companiesData.map(company => {
        let row = {};
        if (visibleFields["Firma Adı"]) row["Firma Adı"] = company.companyName;
        if (visibleFields["Firma Statü"]) row["Firma Statü"] = company.isSubcontractor ? "Alt Firma" : "Üst Firma";
        if (visibleFields["Firma SGK Sicil No"]) row["Firma SGK Sicil No"] = company.companyRegistrationNumber;
        if (visibleFields["Firma Sınıf"]) {
          row["Firma Sınıf"] = company.companyDetails[0]?.companyClass === "ACTIVE" ? "Aktif"
              : company.companyDetails[0]?.companyClass === "INACTIVE" ? "Pasif"
                  : company.companyDetails[0]?.companyClass === "POTENTIAL" ? "Potansiyel"
                      : "Bilinmiyor";
        }
        if (visibleFields["Firma Çalışan Sayısı"]) row["Firma Çalışan Sayısı"] = company.companyDetails[0]?.companyEmployeesCount || "Bilgi Yok";
        if (visibleFields["Firma Tehlike Sınıfı"]) {
          row["Firma Tehlike Sınıfı"] = company.companyDetails[0]?.companyHazardLesson === "LESS_DANGEROUS" ? "Az Tehlikeli"
              : company.companyDetails[0]?.companyHazardLesson === "MANY_DANGEROUS" ? "Çok Tehlikeli"
                  : company.companyDetails[0]?.companyHazardLesson === "DANGEROUS" ? "Tehlikeli"
                      : "Bilgi Yok";
        }
        if (visibleFields["Firma Sektör"]) row["Firma Sektör"] = company.companyDetails[0]?.companySector || "Bilgi Yok";
        if (visibleFields["Firma Segment"]) row["Firma Segment"] = company.companyDetails[0]?.companySegment || "Bilgi Yok";
        if (visibleFields["Firma Adres"]) row["Firma Adres"] = company.companyAddresses[0]?.companyAddress || "Bilgi Yok";
        if (visibleFields["Müşteri Temsilcisi"]) row["Müşteri Temsilcisi"] = company.customerRepresentativeUserId?.name || "Temsilci Yok";
        return row;
      });
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Firmalar");
      XLSX.writeFile(workbook, "Firma_Bilgileri.xlsx");
    },
    addOfficial() {
      this.itemsCompanyOfficials.push({
        nameSurname: '',
        mail: '',
        phoneNumber: '',
      });
    },
    removeOfficial(index) {
      this.itemsCompanyOfficials.splice(index, 1);
    },
    getUserData(){
      apiClient.get("users").then(res =>  {
        this.usersData = res.data;
      })
    },
    resetParentCompany() {
      this.itemsCompany.parentCompany = null;
    },
    setDeleteId(id) {
      this.deleteId = id;
    },
    validateEmployeeCountInput(event){
      const value = event.target.value.replace(/\D/g, '');
      if (value === '') {
        this.itemsDetail.companyEmployeesCount = null;
      } else {
        this.itemsDetail.companyEmployeesCount = value;
      }
    },
    validateSGKNumberInput(event) {
      const value = event.target.value.replace(/\D/g, '');
      if (value === '') {
        this.itemsCompany.companyRegistrationNumber = null;
      } else {
        this.itemsCompany.companyRegistrationNumber = value;
      }
    },
    getCompaniesData(){
      apiClient.get("companies/all").then(res => {
        this.companiesData = res.data;
      });
    },
    getCompaniesSubcontractorData(){
      apiClient.get("companies?status=false").then(res => {
        this.companiesSubcontractData = res.data;
      });
    },
    getCompanySegmentData() {
      apiClient.get("company-detail-info/company-segment").then(res => {
        this.companySegmentData = res.data;
        if (Array.isArray(res.data) && res.data.length > 0) {
          this.items.companySegment = this.companySegmentData[0];
        }
        this.getCompanyLessonData();
      });
    },
    getCompanyLessonData(){
      apiClient.get("company-detail-info/company-lesson").then(res => {
        this.companyLessonData = res.data;
        if (Array.isArray(res.data) && res.data.length > 0) {
          this.items.companyLessonData = this.companyLessonData[0];
        }
        this.getCompanyHazardData();
      });
    },
    getCompanyHazardData() {
      apiClient.get("company-detail-info/company-hazard").then(res => {
        this.companyHazardData = res.data;
        if (Array.isArray(res.data) && res.data.length > 0) {
          this.items.companyHazardLesson = this.companyHazardData[0].id;
        }
      });
    },
    setNullItems(){
      this.itemsCompany = {isSubcontractor:false};
      this.itemsDetail = {};
      this.itemsAddress = {};
      this.itemsCompanyOfficials = {};
    },
    nextStep() {
      if (this.step < 5) {
        this.step += 1;
      }
    },
    previousStep() {
      if (this.step < 5) {
        this.step -= 1;
      }
    },
    companiesDelete(id) {
      apiClient.delete(`/companies/companies-deleted/${id}`)
          .then(() => {
            this.getCompaniesData();
          })
          .catch(error => {
            console.error("Silme işlemi sırasında hata oluştu:", error);
          });
    },

    // ========================================================================================= //
    // ===== BAŞLANGIÇ: Değişiklik yapılan alan ===== //
    // ========================================================================================= //
    editCompany(id) {
      this.isAddingCompany = false;
      apiClient.get(`/companies/${id}`).then(res => {
        console.log("edit data", res.data);

        // API'den gelen veriyi doğrudan atamak yerine bir değişkende tutup işliyoruz.
        const companyData = res.data;

        // --- DÜZELTME 1: Firma Türünü (isSubcontractor) gelen veriye göre ayarla ---
        // Eğer 'parentCompany' alanı dolu ise bu bir alt firmadır (isSubcontractor = true).
        // Eğer 'parentCompany' alanı null ise bu bir ana firmadır (isSubcontractor = false).
        // `!!` operatörü bu dönüşümü (truthy/falsy'den boolean'a) kolayca yapar.
        companyData.isSubcontractor = !!companyData.parentCompany;

        // --- DÜZELTME 2: Müşteri Temsilcisinin sadece ID'sini al ---
        // Dropdown (select), v-model'de basit bir ID beklerken, API'den bir nesne ({id: 2, name: ...}) geliyor.
        // Bu yüzden nesnenin içinden sadece 'id' değerini alarak v-model'in doğru eşleşmesini sağlıyoruz.
        if (companyData.customerRepresentativeUserId && typeof companyData.customerRepresentativeUserId === 'object') {
          companyData.customerRepresentativeUserId = companyData.customerRepresentativeUserId.id;
        }

        // İşlenmiş ve düzeltilmiş verileri component'in data'larına atıyoruz.
        this.itemsCompany = companyData;
        this.itemsDetail = companyData.companyDetails[0] || { companyClass: null };
        this.itemsAddress = companyData.companyAddresses[0] || {}; // Hata almamak için boş obje fallback'i
        this.itemsCompanyOfficials = companyData.companyOfficials || []; // Hata almamak için boş dizi fallback'i
        this.isEditing = true;
      });
    },
    // ========================================================================================= //
    // ===== BİTİŞ: Değişiklik yapılan alan ===== //
    // ========================================================================================= //

    async updateCompany() {
      try {
        // Müşteri temsilcisi ID'sini API'nin beklediği nesne formatına geri çeviriyoruz.
        this.itemsCompany.customerRepresentativeUserId = {
          id: this.itemsCompany.customerRepresentativeUserId
        };

        const companyRes = await apiClient.put(`/companies/${this.itemsCompany.id}`, this.itemsCompany);
        let data = {id: companyRes.data};

        this.itemsDetail.companiesId = data;
        this.itemsAddress.companiesId = data;
        this.itemsCompanyOfficials.forEach(official => {
          official.companiesId = data;
        });

        await Promise.all([
          this.putCompanyDetails(),
          this.putCompanyAddress(),
          this.putCompanyOfficials()
        ]);

        this.setNullItems();
        await this.getCompaniesData();

        if (this.companyModal) {
          this.companyModal.hide();
        } else {
          const modal = document.getElementById('exampleModal');
          const modalInstance = bootstrap.Modal.getInstance(modal);
          if (modalInstance) {
            modalInstance.hide();
          }
        }
        // cleanupModal metodu hidden.bs.modal event'i ile otomatik çağrılacak

      } catch (error) {
        console.error('Güncelleme hatası:', error);
      }
    },

    async putCompanyDetails() {
      this.itemsDetail.companiesId = { id: this.itemsCompany.id };
      return await apiClient.put(`/companyDetails/${this.itemsDetail.id}`, this.itemsDetail);
    },

    async putCompanyAddress() {
      this.itemsAddress.companiesId = { id: this.itemsCompany.id };
      return await apiClient.put(`/companyAddress/${this.itemsAddress.id}`, this.itemsAddress);
    },

    async putCompanyOfficials() {
      if (Array.isArray(this.itemsCompanyOfficials)) {
        const promises = this.itemsCompanyOfficials.map(official => {
          official.companiesId = { id: this.itemsCompany.id };
          // Yeni eklenen yetkililerde ID olmayabilir, bu durumu kontrol et
          if (official.id) {
            return apiClient.put(`/companyOfficials/${official.id}`, official);
          } else {
            // ID'si olmayan yeni yetkiliyi post ile ekleyebilirsiniz, bu kısım projenizin yapısına bağlı
            // return apiClient.post(`/companyOfficials`, official);
          }
        });

        return await Promise.all(promises);
      }
    },
    createCompany() {
      this.itemsCompany.customerRepresentativeUserId = {
        id: this.itemsCompany.customerRepresentativeUserId
      };

      apiClient.post("/companies", this.itemsCompany)
          .then(res => {
            let data = {id: res.data}
            this.itemsDetail.companiesId = data;
            this.itemsAddress.companiesId = data;

            this.itemsCompanyOfficials.forEach(official => {
              official.companiesId = data;
            });

            return Promise.all([
              this.postCompanyDetails(),
              this.postCompanyAddress(),
              this.postCompanyOfficials()
            ]);
          })
          .then(() => {
            this.setNullItems();
            this.resetForm();

            if (this.companyModal) {
              this.companyModal.hide();
            } else {
              const modal = document.getElementById('exampleModal');
              const modalInstance = bootstrap.Modal.getInstance(modal);
              if (modalInstance) {
                modalInstance.hide();
              }
            }
            // cleanupModal metodu hidden.bs.modal event'i ile otomatik çağrılacak

            setTimeout(() => {
              this.getCompaniesData();
            }, 500);
          })
          .catch(error => {
            console.error("Hata oluştu:", error);
          });
    },

    resetForm() {
      this.step = 1;
      this.itemsCompany = {
        isSubcontractor: false,
        parentCompany: null,
        customerRepresentativeUserId: null,
        companyName: '',
        companyRegistrationNumber: null
      };
      this.itemsDetail = {
        companyClass: null,
        companyEmployeesCount: null,
        companyHazardLesson: null,
        companySector: '',
        companySegment: null
      };
      this.itemsAddress = {
        companyAddress: '',
        companyDistrict: '',
        companyCity: ''
      };
      this.itemsCompanyOfficials = [{
        nameSurname: '',
        email: '',
        phoneNumber: '',
        jobTitle: ''
      }];
    },
    postCompanyOfficials(){
      apiClient.post("/companyOfficials", this.itemsCompanyOfficials).then(res => {
        console.log("companyOfficials", res.data);
      })
    },
    postCompanyDetails(){
      apiClient.post("/companyDetails", this.itemsDetail).then(res => {
        console.log("companyDetails", res.data);
      })
    },
    postCompanyAddress(){
      apiClient.post("/companyAddress", this.itemsAddress).then(res => {
        console.log("companyAddress", res.data);
      })
    },

  },
}
</script>

<style scoped>
.wide-modal {
  width: 1000px !important;
  display: flex;
  flex-direction: column;
  margin-left: -150px;
}

.modal-dialog-centered {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.break-line {
  white-space: normal;
  word-wrap: break-word;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.pagination button {
  padding: 8px 12px;
  margin: 5px;
  border: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  border-radius: 5px;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>
